module.exports = __webpack_public_path__ + "img/162018.c0ea7f32.jpg";